// extracted by mini-css-extract-plugin
export default {"CustomRow":"CustomRow_CustomRow__vCJqZ","isExpanded":"CustomRow_isExpanded__KmbNN"};